import { render } from "./DialogUnresolveContact.vue?vue&type=template&id=6fdbc9ce&scoped=true"
import script from "./DialogUnresolveContact.vue?vue&type=script&lang=js"
export * from "./DialogUnresolveContact.vue?vue&type=script&lang=js"

import "./DialogUnresolveContact.vue?vue&type=style&index=0&id=6fdbc9ce&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdbc9ce"]])

export default __exports__